import CreateLeadForm from '../CreateLeadForm/CreateLeadForm'
import './NewLead.css'

export default function NewLead({user, getLeads, toggleNotifications}) {
  return (
    <div className='NewLead modal fade' id='newLeadModal'  data-bs-keyboard="true" aria-labelledby={`newLeadHeader`}>
        <CreateLeadForm user={user} getLeads={getLeads} toggleNotifications={toggleNotifications} />
    </div>
  )
}
